import { render, staticRenderFns } from "./StoryMentionReply.vue?vue&type=template&id=dc2a1194&"
import script from "./StoryMentionReply.vue?vue&type=script&lang=js&"
export * from "./StoryMentionReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports